import {
    SidebarAudiencesProps,
    SidebarAudiencesViewProps,
} from './types'
import {
    getQueueAudiences,
    getRealmAudiences,
} from 'selectors/ninchat'

import {NinchatState} from 'api/types'
import {NinchatStoreUserChannel} from 'api/types/store'
import React from 'react'
import SidebarAudiencesView from './SidebarAudiencesView'
import {UserID} from 'api/types/properties'

import {getGroupQueues} from 'selectors/ninchat/groups'
import {
    orderBy,
} from 'lodash'
import {useAppSelector} from 'hooks'

// eslint-disable-next-line max-len
const filterAudiences = (audienceChannels: Array<NinchatStoreUserChannel>, currentUserId: UserID): Array<NinchatStoreUserChannel> => audienceChannels.filter((currentChannel) => currentChannel.channel_members?.[currentUserId]?.member_attrs?.invitee !== true)
// sort audience channel in descending order by their create_time attribute
const sortAudiences = (audienceChannels: Array<NinchatStoreUserChannel>): Array<string> => {
    const audiences = orderBy(audienceChannels ?? [], (item) => item.channel_attrs?.create_time, ['desc'])
    return audiences.map((item: Record<string, unknown>): string => item.channel_id as string)
}

const SidebarAudiences = ({
    queue_id, realm_id, queue_attrs,
}: SidebarAudiencesProps): React.ReactElement => {
    const isGroupQueue = !!queue_attrs?.is_group

    const groupQueues = useAppSelector((state) => getGroupQueues(state, isGroupQueue, queue_id || ''))
    const getAudiences = (ninchat: NinchatState) => {
        if (isGroupQueue) {
            return groupQueues.reduce((acc, q) => {
                const audiences = getQueueAudiences(ninchat, q.id)
                return acc.concat(audiences)
            }, [] as Array<NinchatStoreUserChannel>)
        }

        if (queue_id) {
            return getQueueAudiences(ninchat, queue_id)
        }
        return []
    }


    const audiencesViewProps = useAppSelector(({ninchat}): SidebarAudiencesViewProps => {
        const audienceList = queue_id ? getAudiences(ninchat) : realm_id ? getRealmAudiences(ninchat, realm_id) : []
        // if queue id is provided that means it is going to be a nested view
        const nestedView = Boolean(queue_id)
        const filteredAudiences = ninchat.user_id ? filterAudiences(audienceList ?? [], ninchat.user_id) : []
        return {
            audiences: ninchat.user_id ? sortAudiences(filteredAudiences) : [],
            nested: nestedView,
        }
    })


    return (
        <>
            {
                audiencesViewProps?.audiences.length > 0 &&
                <SidebarAudiencesView
                    audiences={audiencesViewProps.audiences}
                    isGroupQueue={isGroupQueue}
                    nested={audiencesViewProps.nested}
                />
            }
            {}
        </>

    )
}

export default SidebarAudiences
